export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDLCNYPGwJw1m6VTS-_279k6QWB0w7Jf2k",
    authDomain: "rare-habitat-128113.firebaseapp.com",
    projectId: "rare-habitat-128113",
    storageBucket: "rare-habitat-128113.firebasestorage.app",
    messagingSenderId: "174506989184",
    appId: "1:174506989184:web:45b8c420d5fbbd5598f865",
    measurementId: "G-B9H1VQ2MMQ"
  },
  useEmulators: true,
  enableDevAdminBootstrap: false,
};
